import React from "react";

import "./SkillsGrid.scss";

export interface ISkillsGridRowPartProps {
  name?: string;
  level?: string;
  skillsName: string[];
}

export const SkillsGridRowPart: React.FC<
  React.PropsWithChildren<ISkillsGridRowPartProps>
> = ({ name, level, skillsName }) => {
  const mobileLevelLabel = level && (
    <span className="c-skill-grid__level-mobile">{level}:&nbsp;</span>
  );

  const levelLabel = level && (
    <span className="c-skill-grid__level">{level}:</span>
  );

  const categoryClasses = `c-skill-grid__category-name ${!name ? "empty" : ""}`;

  return (
    <div className="c-skill-grid__row-part g-content-area">
      <th className="c-skill-grid__name g-col-md-2 g-col-lg-3">
        <div className={categoryClasses}>{name || <span>&nbsp;</span>}</div>
        {levelLabel}
      </th>
      <td className="c-skill-grid__values-section g-col-md-10 g-col-lg-9">
        {mobileLevelLabel}
        <span className="c-skill-grid__values">{skillsName.join(", ")}</span>
      </td>
    </div>
  );
};
